import { render, staticRenderFns } from "./iam-new-page.vue?vue&type=template&id=56dde387&"
import script from "./iam-new-page.vue?vue&type=script&lang=js&"
export * from "./iam-new-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports